import React, { useEffect, useState } from "react";
// import Form from "react-bootstrap/Form";
// import { connect } from "react-redux";
// import CustomButton from "../../utils/button/button";
import OTPInput from "../OTPInput";
import "./otp.css";
import OTPPopup from "./OTPPopup";

const OtpScreen = (props) => {
  const {
    handleSubmit,
    setOtp,
    heading,
    mobile,
    handleLoginWithOtp,
    handleLoginWithOTPOnCall,
    setCount,
    getTextTranslated,
  } = props;
  const [countDown, setCountDown] = useState(30);
  // const handleVerify = (e) => {
  //   e.preventDefault();
  // };

  const [showOtpPopup, setShowOtpPopup] = useState(false);

  useEffect(() => {
    const timer =
      countDown > 0 && setInterval(() => setCountDown(countDown - 1), 1000);
    return () => {
      clearInterval(timer);
    };
  }, [countDown]);

  const handleResend = async (e) => {
    // handleSubmit && handleSubmit(e, "resendOtp");
    const response = await handleLoginWithOtp();
    if (response?.errorCode === "SO0005") {
      setShowOtpPopup(false);
    } else {
      setCountDown(30);
      setShowOtpPopup(false);
    }
  };

  const handleResendOnCall = (e) => {
    handleLoginWithOTPOnCall();

    setCountDown(30);
    setShowOtpPopup(false);
  };

  return (
    <>
      <div className="flex flex-col items-center justify-center">
        <div className="Login-Head">
          <h2 className="text-[22px] md:text-[32px] font-medium mb-5">
            {heading && heading}
          </h2>
          <p>
            {getTextTranslated?.data?.length > 0
              ? getTextTranslated?.data?.filter(
                  (item) => item.pageKey === "error_enter_otp"
                )[0].keyValue
              : "Enter the OTP sent to your mobile number."}
          </p>
          <p className="pt-2">
            {mobile}{" "}
            {/* <button className="text-[#12afff]" onClick={() => setCount(0)}>
            Change
          </button> */}
          </p>
        </div>
        {/* OTP number enter */}
        <OTPInput
          autoFocus
          //isNumberInput
          length={6}
          className="otpContainer"
          inputClassName="otpInput"
          onChangeOTP={
            setOtp &&
            ((otp) => {
              setOtp(otp);
            })
          }
        />
        {/* Verify Button */}
        {/* <button
        text="Verify"
        classname="blue-btn"
        onClick={handleSubmit && ((e) => handleSubmit(e, "otp"))}
      /> */}
        {/* Resend Otp */}
        <div className="flex mb-[25px]">
          {/* <p className="resend-otp-text"> */}
          {countDown === 0 ? (
            // <button
            //   className="border rounded-md py-1 px-3 border-[#212E6F] text-[#212E6F] m-0"
            //   onClick={handleResend}
            // >
            //   &nbsp;
            //   {getTextTranslated?.data?.length > 0
            //     ? getTextTranslated?.data?.filter(
            //         (item) => item.pageKey === "resend_otp"
            //       )[0].keyValue
            //     : "Resend OTP"}
            // </button>
            <div className="flex gap-10">
              {/* Resend OTP Button */}
              {/* <button
              className="border rounded-md py-1 px-3 border-[#212E6F] text-[#212E6F] m-0"
              onClick={handleResend}
            >
              &nbsp;
              {getTextTranslated?.data?.length > 0
                ? getTextTranslated?.data?.filter(
                    (item) => item.pageKey === "resend_otp"
                  )[0].keyValue
                : "Resend OTP"}
            </button> */}

              {/* OTP on Call Button */}
              {/* <button
              className="border rounded-md py-1 px-3 border-[#212E6F] text-[#212E6F] m-0"
              onClick={handleResendOnCall}
            >
              OTP on call
            </button> */}
              <p
                className="text-left text-[#4182FF] font-semibold cursor-pointer"
                onClick={() => setShowOtpPopup(true)}
              >
                {getTextTranslated?.data?.length > 0
                  ? getTextTranslated?.data?.filter(
                      (item) => item.pageKey === "resend_otp"
                    )[0].keyValue
                  : "Resend OTP"}
              </p>
            </div>
          ) : (
            <p className="">
              {" "}
              {getTextTranslated?.data?.length > 0
                ? getTextTranslated?.data?.filter(
                    (item) => item.pageKey === "resend_sms"
                  )[0].keyValue
                : "Resend in"}{" "}
              {countDown}s
            </p>
          )}
          {/* </p> */}
          {/* <button
          className="border rounded-md py-1 px-6 border-[#212E6F] text-[#212E6F]"
          disabled
        >
          Call me
        </button> */}
        </div>

        {/* <div className="or-seperator">
        <hr />
        <p>or</p>
      </div>

      <div>
        <p className="resend-otp-text">
          <a href="#">Get Via Call</a>
        </p>
      </div> */}
      </div>
      <>
        <OTPPopup
          visible={showOtpPopup}
          onClose={() => setShowOtpPopup(false)}
          handleOtpCall={handleResendOnCall}
          handleOtpWhatsapp={handleResend}
          getTranslateText={getTextTranslated}
        />
      </>
    </>
  );
};

export default OtpScreen;
